import React, { useState } from 'react';
import { KeyboardDatePicker } from '@material-ui/pickers';

const DataPikers = (props) => {
  const {
    minDate,
    maxDate,
    onChange,
    value,
    disablePast = false,
    inputVariant,
    variant = 'inline',
    label = '',
    format = '"yyyy/MM/dd"',
    placeholder = 'Año/Mes/Dia',
  } = props;

  const [date, handleDateChange] = useState(value || new Date());

  const handleChangeComplete = (dateChange) => {
    handleDateChange(dateChange);
    onChange(dateChange);
  };

  return (
    <>
      <KeyboardDatePicker
        variant={variant}
        autoOk
        inputVariant={inputVariant}
        label={label}
        placeholder={placeholder}
        minDateMessage={`Fecha mínima ${minDate}`}
        maxDateMessage={`Fecha máxima ${maxDate}`}
        minDate={minDate}
        maxDate={maxDate}
        invalidDateMessage="Selecciona una fecha valida"
        value={date}
        onChange={(newDate) => handleChangeComplete(newDate)}
        disablePast={disablePast}
        format={format}
        fullWidth
      />
    </>
  );
};

export default DataPikers;
